export { default as AreaDetailsContainer } from './AreaDetails/AreaDetailsContainer'
export { default as CropTypeDetailsContainer } from './CropTypeDetails/CropTypeDetailsContainer'
export { default as FertilizerDetailsContainer } from './Manure/ManureDetailsContainer'
export { default as FarmerNumber } from './Farmer/FarmerNumber'
export { default as UserDetailsContainer } from './UserDetails/UserDetailsContainer'